import { clearOnboardingSession } from "./onboarding_api_helper"

/**
 * Clears onboarding session data on full page reload so forms are not pre-filled.
 * In-flow back navigation (SPA) does not trigger this.
 */
export const clearOnboardingIfPageReloaded = () => {
  if (typeof window === "undefined") {
    return false
  }
  const navEntry = performance.getEntriesByType?.("navigation")?.[0]
  if (navEntry?.type === "reload") {
    clearOnboardingSession()
    return true
  }
  return false
}
